<mat-sidenav-container id="sidenav-container">

  <div id="app-content-wrapper" class="wrapper"
    [ngClass]="{'overscrollBgColorFix': (varService.overscrollBgColorFix$ | async)}">

    <div class="toolbar">
      <mat-toolbar color="primary">

        <span routerLink="">
          PWA
        </span>

        <span class="spacer"></span>

        <button mat-button class="nav-button" [routerLink]="''" routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }">
          Topbar color problem
        </button>

        <!-- <button mat-button class="nav-button" [routerLink]="'list/dom-rendering'" routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }">
          Dom rendering problem
        </button> -->

        <span class="ms-1 me-1">

          <div class="initialsCircle" content-type="template" placement="left" routerLink="my-profile">
            <span class="initials">?</span>
          </div>

        </span>

      </mat-toolbar>
    </div>

    <div class="content">
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </div>

  </div>

</mat-sidenav-container>